export default "/_next/static/images/932e7693f6ae12a9fa144b9550c782f8.png";